// Отдельная страница /teachers: все преподаватели платформы списком — Лидеры, Новые (без уроков),
// Остальные. В строке: фото, возраст, опыт, рейтинг, уроков проведено, цена с карточки, ближайшие
// окошки; по клику — анкета, пометка отдела преподавателей и свободное время по дням недели.
// Данные — те же, что в окне подбора: GET /api/platform/tutors (предмет обязателен), окошки
// приходят тем же запросом (?slots=1). Макет: crm.ctg.school/preview/_tutors-list-preview.html.
import { useState, useEffect, useMemo } from 'react'
import api from '../api'

const SUBJECTS = ['Математика', 'Русский', 'Физика', 'Химия', 'Английский', 'Биология', 'Обществознание',
  'История', 'Информатика', 'География', 'Окружающий мир', 'Немецкий', 'Психология']
const CLASS_OPTS = [
  { v: '', l: 'Любой класс' },
  ...['1', '2', '3', '4', '5', '6', '7', '8'].map((x) => ({ v: x, l: x + ' класс' })),
  { v: 'ОГЭ', l: '9 класс · ОГЭ' },
  { v: 'ЕГЭ', l: '10–11 класс · ЕГЭ' },
]
const TIME_OPTS = [
  { v: 'any', l: 'Свободны: в любое время' },
  { v: 'today', l: 'Сегодня' },
  { v: 'tomorrow', l: 'Завтра' },
  { v: 'week', l: 'На этой неделе' },
]
const WD = ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб']
const GROUPS = [
  { k: 'lead', title: 'Лидеры', col: '#B45309', bg: '#FEF3C7' },
  { k: 'new', title: 'Новые, ещё без уроков', col: '#0369A1', bg: '#E0F2FE' },
  { k: 'rest', title: 'Остальные', col: '#475569', bg: '#F1F5F9' },
]
const PAGE = 30

// «сегодня» по Москве: сервер СРМ тоже считает окошки по МСК
function mskDays(n) {
  const base = Date.now() + 3 * 3600 * 1000
  const out = []
  for (let i = 0; i < n; i++) {
    const d = new Date(base + i * 86400000)
    out.push({ iso: d.toISOString().slice(0, 10), wd: WD[d.getUTCDay()], dm: d.getUTCDate() })
  }
  return out
}

function matchClass(t, c) {
  if (!c) return true
  const lv = (t.classLevels || []).map(String)
  if (c === 'ОГЭ') return lv.includes('ОГЭ') || lv.includes('9')
  if (c === 'ЕГЭ') return lv.includes('ЕГЭ') || lv.includes('10') || lv.includes('11')
  return lv.includes(c)
}
function groupOf(t) {
  if (t.isLeader) return 'lead'
  if (!t.lessonsCount) return 'new'
  return 'rest'
}
function plain(v) {
  if (v == null || v === '') return ''
  if (Array.isArray(v)) return v.filter((x) => typeof x === 'string' || typeof x === 'number').join(', ')
  if (typeof v === 'string' || typeof v === 'number') return String(v)
  return ''
}
// Внутренний балл 0–100 (платформа teacher-score, 90 дней) и конверсия первых уроков: оставшиеся / пришедшие
function scoreCls(v) { return v == null ? 'n' : v >= 80 ? 'g' : v >= 60 ? 'y' : 'r' }
function convCls(v) { return v == null ? 'n' : v >= 70 ? 'g' : v >= 50 ? 'y' : 'r' }
function statsOf(t) {
  const sc = t.score || null
  const score = sc && sc.score != null ? sc.score : null
  const conv = sc && sc.first_conv_pct != null ? sc.first_conv_pct : null
  const convSub = !sc ? 'нет первых уроков' : conv == null ? (sc.first_lessons ? 'мало данных' : 'нет первых уроков') : sc.first_kept + ' из ' + sc.first_lessons + ' остались'
  return { score, conv, convSub, scoreSub: score == null ? 'нет данных' : 'из 100' }
}
function photoSrc(p) { return p ? (/^https?:/.test(p) ? p : 'https://ctg.school' + p) : null }
function ruWord(n, a, b, c) {
  const m = Math.abs(n) % 100, d = m % 10
  if (m > 10 && m < 20) return c
  if (d > 1 && d < 5) return b
  return d === 1 ? a : c
}

const css = `
.tl-wrap{max-width:1180px;margin:0 auto;padding:18px 20px 60px;font-family:Inter,system-ui,Arial,sans-serif;font-size:14px;color:#0F172A}
.tl-bar{background:#fff;border-bottom:1px solid #E2E8F0;padding:10px 20px;display:flex;gap:12px;align-items:center;flex-wrap:wrap}
.tl-bar a{color:#0369A1;text-decoration:none;font-size:13.5px;font-weight:600}
.tl-bar .nm{margin-left:auto;color:#64748B;font-size:13px}
.tl-h1{font-size:21px;font-weight:700;margin:6px 0 2px}
.tl-lead{color:#64748B;margin:0 0 14px}
.tl-filters{display:flex;gap:8px;flex-wrap:wrap;align-items:center;background:#fff;border:1px solid #E2E8F0;border-radius:14px;padding:10px 12px;margin-bottom:12px}
.tl-filters input,.tl-filters select{border:1px solid #E2E8F0;border-radius:10px;padding:8px 10px;font:inherit;background:#fff}
.tl-filters input{flex:1;min-width:200px}
.tl-chip{border:1px solid #E2E8F0;background:#fff;border-radius:999px;padding:6px 12px;font-size:13px;cursor:pointer;font-family:inherit}
.tl-chip.on{background:#0369A1;border-color:#0369A1;color:#fff}
.tl-gh{display:flex;align-items:center;gap:8px;margin:22px 0 8px}
.tl-gh h3{margin:0;font-size:16px;font-weight:700}
.tl-dot{width:10px;height:10px;border-radius:50%}
.tl-cnt{border-radius:999px;padding:1px 9px;font-size:12px;font-weight:700}
.tl-row{background:#fff;border:1px solid #E2E8F0;border-radius:14px;margin-bottom:8px;overflow:hidden}
.tl-row:hover{border-color:#BAE6FD}
.tl-top{display:grid;grid-template-columns:48px minmax(190px,1.5fr) 84px 96px 84px 96px 108px minmax(170px,1.2fr) 18px;gap:12px;align-items:center;padding:10px 14px;cursor:pointer}
.tl-ph{width:48px;height:48px;border-radius:12px;object-fit:cover;background:#E2E8F0}
.tl-nm{font-weight:600}
.tl-sub{color:#64748B;font-size:12.5px;margin-top:2px}
.tl-cell b{display:block;font-size:14px}
.tl-cell span.s{display:block;color:#64748B;font-size:11.5px}
.tl-lab{display:block;color:#64748B;font-size:11.5px;margin-bottom:3px}
.tl-sl{display:inline-block;background:#ECFDF5;color:#065F46;border:1px solid #A7F3D0;border-radius:7px;padding:1px 6px;margin:1px 3px 1px 0;font-size:11.5px}
.tl-none{color:#94A3B8;font-size:12px}
.tl-chev{color:#94A3B8;transition:transform .15s}
.tl-row.open .tl-chev{transform:rotate(180deg)}
.tl-det{display:none;border-top:1px solid #F1F5F9;padding:14px 18px;grid-template-columns:1.2fr 1fr;gap:24px;background:#FCFDFE}
.tl-row.open .tl-det{display:grid}
.tl-det h5{margin:0 0 6px;font-size:12px;letter-spacing:.05em;text-transform:uppercase;color:#64748B;font-weight:600}
.tl-det p{margin:0 0 8px;line-height:1.5}
.tl-desc{white-space:pre-wrap;max-height:260px;overflow:auto}
.tl-muted{color:#475569;font-size:13px}
.tl-note{background:#FFF7ED;border:1px solid #FED7AA;border-radius:10px;padding:8px 10px;color:#7C2D12;font-size:13px;margin-bottom:10px}
.tl-week{display:grid;grid-template-columns:repeat(7,1fr);gap:4px}
.tl-week div{border:1px solid #E2E8F0;border-radius:8px;padding:4px;min-height:54px;font-size:11px}
.tl-week i{display:block;font-style:normal;color:#64748B;font-weight:600;margin-bottom:2px}
.tl-more{background:none;border:0;color:#0369A1;font-weight:600;cursor:pointer;padding:8px;font-family:inherit;font-size:13px;display:block;margin:0 auto}
.tl-state{color:#64748B;text-align:center;padding:40px 10px}
.tl-sc{display:inline-flex;align-items:center;justify-content:center;min-width:44px;height:28px;border-radius:9px;font-weight:800;font-size:14px;padding:0 8px}
.tl-sc.g{background:#DCFCE7;color:#166534}.tl-sc.y{background:#FEF3C7;color:#92400E}.tl-sc.r{background:#FEE2E2;color:#991B1B}.tl-sc.n{background:#F1F5F9;color:#94A3B8;font-weight:600}
.tl-stats{grid-column:1/-1;display:flex;gap:10px;flex-wrap:wrap}
.tl-stat{border:1px solid #E2E8F0;background:#fff;border-radius:10px;padding:8px 12px;min-width:140px}
.tl-stat b{display:block;font-size:16px}.tl-stat span{color:#64748B;font-size:12px}
@media(max-width:900px){.tl-top{grid-template-columns:48px 1fr 18px}.tl-top .tl-cell{display:none}.tl-det{grid-template-columns:1fr}}
`

function Row({ t, days }) {
  const [open, setOpen] = useState(false)
  const pg = t.priceGrid || {}
  const cls = String(t.classes || '').replace(/^Классы и уровни:\s*/i, '')
  const slots = t.slots || {}
  const first = []
  days.forEach((d, i) => (slots[d.iso] || []).forEach((tm) => {
    if (first.length < 6) first.push((i === 0 ? 'Сегодня' : i === 1 ? 'Завтра' : d.wd) + ' ' + tm)
  }))
  const note = t.otbor && t.otbor.note
  const extra = [plain(t.programs), plain(t.lesson_format)].filter(Boolean).join(' · ')
  const src = photoSrc(t.photo)
  const st = statsOf(t)
  return (
    <div className={'tl-row' + (open ? ' open' : '')}>
      <div className="tl-top" onClick={() => setOpen(!open)}>
        {src ? <img className="tl-ph" src={src} alt="" loading="lazy" onError={(e) => { e.target.style.visibility = 'hidden' }} /> : <div className="tl-ph" />}
        <div>
          <div className="tl-nm">{t.name}</div>
          <div className="tl-sub">{t.age ? t.age + ' ' + ruWord(t.age, 'год', 'года', 'лет') + ' · ' : ''}опыт {t.experience || '—'} · классы: {cls || '—'}</div>
        </div>
        <div className="tl-cell"><b>{t.rating != null ? Number(t.rating).toFixed(1) : '—'}</b><span className="s">оценка, {t.reviewCount || 0} {ruWord(t.reviewCount || 0, 'отзыв', 'отзыва', 'отзывов')}</span></div>
        <div className="tl-cell"><b>{t.lessonsCount || 0}</b><span className="s">{ruWord(t.lessonsCount || 0, 'урок', 'урока', 'уроков')} проведено</span></div>
        <div className="tl-cell" title="Внутренний балл за 90 дней"><span className={'tl-sc ' + scoreCls(st.score)}>{st.score != null ? st.score : '—'}</span><span className="s" style={{ marginTop: 3 }}>{st.scoreSub}</span></div>
        <div className="tl-cell" title="Из пришедших на первый урок сколько остались заниматься, за 90 дней"><span className={'tl-sc ' + convCls(st.conv)}>{st.conv != null ? st.conv + '%' : '—'}</span><span className="s" style={{ marginTop: 3 }}>{st.convSub}</span></div>
        <div className="tl-cell"><b>{t.price != null ? t.price + ' ₽' : '—'}</b>{pg.oge ? <span className="s">ОГЭ {pg.oge} · ЕГЭ {pg.ege}</span> : null}</div>
        <div className="tl-cell">
          <span className="tl-lab">Ближайшие окошки</span>
          {first.length ? first.map((s) => <span key={s} className="tl-sl">{s}</span>) : <span className="tl-none">на 7 дней свободных нет</span>}
        </div>
        <div className="tl-chev">▾</div>
      </div>
      <div className="tl-det">
        <div className="tl-stats">
          <div className="tl-stat"><b>{st.score != null ? st.score + ' из 100' : '—'}</b><span>внутренний балл, 90 дней</span></div>
          <div className="tl-stat"><b>{st.conv != null ? st.conv + '%' : '—'}</b><span>конверсия первых уроков ({st.convSub})</span></div>
          <div className="tl-stat"><b>{t.rating != null ? Number(t.rating).toFixed(1) : '—'}</b><span>оценка учеников, {t.reviewCount || 0} {ruWord(t.reviewCount || 0, 'отзыв', 'отзыва', 'отзывов')}</span></div>
        </div>
        <div>
          <h5>Анкета</h5>
          {t.desc ? <p className="tl-desc">{t.desc}</p> : <p className="tl-muted">Текст «о себе» не заполнен.</p>}
          {t.education ? <p className="tl-muted"><b>Образование:</b> {plain(t.education)}</p> : null}
          {extra ? <p className="tl-muted"><b>Программы и формат:</b> {extra}</p> : null}
          <p className="tl-muted"><b>Видео о себе:</b> {t.hasVideo ? 'есть' : 'нет'}{t.timezone ? <>{' '}&nbsp; <b>Часовой пояс:</b> {plain(t.timezone)}</> : null}</p>
        </div>
        <div>
          <h5>Пометка отдела преподавателей</h5>
          <div className="tl-note">{note || 'Пометок нет'}</div>
          <h5>Свободное время на неделю</h5>
          <div className="tl-week">
            {days.map((d) => (
              <div key={d.iso}><i>{d.wd} {d.dm}</i>{(slots[d.iso] || []).map((tm) => <span key={tm} className="tl-sl">{tm}</span>)}</div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default function TutorsListPage() {
  const [subject, setSubject] = useState('Математика')
  const [cls, setCls] = useState('')
  const [timeF, setTimeF] = useState('any')
  const [q, setQ] = useState('')
  const [grp, setGrp] = useState('all')
  const [list, setList] = useState(null)
  const [err, setErr] = useState('')
  const [lim, setLim] = useState({ lead: PAGE, new: PAGE, rest: PAGE })
  const days = useMemo(() => mskDays(7), [subject]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    let alive = true
    setList(null); setErr('')
    api.get('/api/platform/tutors', {
      params: { subject, grade: cls || undefined, slots: 1, dateFrom: days[0].iso, dateTo: days[6].iso },
    }).then((r) => { if (alive) setList((r.data && r.data.tutors) || []) })
      .catch(() => { if (alive) setErr('Платформа не ответила. Попробуйте обновить страницу через минуту.') })
    return () => { alive = false }
  }, [subject, cls, days])

  const filtered = useMemo(() => {
    if (!list) return []
    const s = q.trim().toLowerCase()
    return list.filter((t) => {
      if (s && !String(t.name || '').toLowerCase().includes(s)) return false
      if (!matchClass(t, cls)) return false
      if (timeF !== 'any') {
        const n = timeF === 'today' ? [0] : timeF === 'tomorrow' ? [1] : [0, 1, 2, 3, 4, 5, 6]
        if (!n.some((i) => ((t.slots || {})[days[i].iso] || []).length)) return false
      }
      return true
    })
  }, [list, q, cls, timeF, days])

  const byGroup = useMemo(() => {
    const m = { lead: [], new: [], rest: [] }
    filtered.forEach((t) => m[groupOf(t)].push(t))
    return m
  }, [filtered])

  const name = localStorage.getItem('name') || ''
  return (
    <div style={{ background: '#F8FAFC', minHeight: '100vh' }}>
      <style>{css}</style>
      <div className="tl-bar">
        <a href="/">← Вернуться в кабинет</a>
        <span className="nm">{name}</span>
      </div>
      <div className="tl-wrap">
        <div className="tl-h1">Преподаватели</div>
        <p className="tl-lead">Все преподаватели платформы одним списком: кто Лидер, кто новый, кто остальные. Нажмите на строку — откроется анкета и свободное время.</p>
        <div className="tl-filters">
          <input placeholder="Поиск по имени преподавателя" value={q} onChange={(e) => setQ(e.target.value)} />
          <select value={subject} onChange={(e) => { setSubject(e.target.value); setLim({ lead: PAGE, new: PAGE, rest: PAGE }) }}>
            {SUBJECTS.map((s) => <option key={s} value={s}>Предмет: {s}</option>)}
          </select>
          <select value={cls} onChange={(e) => setCls(e.target.value)}>
            {CLASS_OPTS.map((o) => <option key={o.v} value={o.v}>{o.v ? 'Класс ученика: ' : ''}{o.l}</option>)}
          </select>
          <select value={timeF} onChange={(e) => setTimeF(e.target.value)}>
            {TIME_OPTS.map((o) => <option key={o.v} value={o.v}>{o.l}</option>)}
          </select>
          <button className={'tl-chip' + (grp === 'all' ? ' on' : '')} onClick={() => setGrp('all')}>Все {filtered.length}</button>
          {GROUPS.map((g) => (
            <button key={g.k} className={'tl-chip' + (grp === g.k ? ' on' : '')} onClick={() => setGrp(g.k)}>
              {g.k === 'lead' ? 'Лидеры' : g.k === 'new' ? 'Новые' : 'Остальные'} {byGroup[g.k].length}
            </button>
          ))}
        </div>
        {err && <div className="tl-state">{err}</div>}
        {!err && list === null && <div className="tl-state">Загружаю преподавателей и свободное время…</div>}
        {!err && list !== null && filtered.length === 0 && <div className="tl-state">По выбранным условиям никого нет. Попробуйте другой класс или время.</div>}
        {!err && list !== null && GROUPS.filter((g) => (grp === 'all' || grp === g.k) && byGroup[g.k].length).map((g) => (
          <section key={g.k}>
            <div className="tl-gh">
              <span className="tl-dot" style={{ background: g.col }} />
              <h3>{g.title}</h3>
              <span className="tl-cnt" style={{ background: g.bg, color: g.col }}>{byGroup[g.k].length}</span>
            </div>
            {byGroup[g.k].slice(0, lim[g.k]).map((t) => <Row key={t.mkId} t={t} days={days} />)}
            {byGroup[g.k].length > lim[g.k] && (
              <button className="tl-more" onClick={() => setLim({ ...lim, [g.k]: lim[g.k] + PAGE })}>
                Показать ещё {Math.min(PAGE, byGroup[g.k].length - lim[g.k])} из {byGroup[g.k].length - lim[g.k]}
              </button>
            )}
          </section>
        ))}
      </div>
    </div>
  )
}
